import clsx from "clsx";
import "react-json-view-lite/dist/index.css";
import { defaultStyles, JsonView as LibJsonView } from "react-json-view-lite";

import s from "./JsonViewer.module.css";

interface JsonViewerProps {
  className?: string;
  collapseDepth?: number;
  data: unknown;
}

const styles = {
  ...defaultStyles,
  container: s.container,
  basicChildStyle: s.line,
  label: s.key,
  punctuation: s.punctuation,
  stringValue: s.stringValue,
  numberValue: s.numberValue,
  booleanValue: s.booleanValue,
  nullValue: s.nullValue,
  undefinedValue: s.nullValue,
  collapseIcon: s.icon,
  expandIcon: s.icon,
  collapsedContent: s.collapsed,
};

export const JsonViewer = ({
  data,
  collapseDepth = 10,
  className,
}: JsonViewerProps) => {
  return (
    <div className={clsx(s.wrapper, className)}>
      <LibJsonView
        data={(data ?? null) as Record<string, unknown>}
        shouldExpandNode={(level: number) => level < collapseDepth}
        style={styles}
      />
    </div>
  );
};
